export default __webpack_public_path__ + "static/media/auth-background.7e9d4c35.jpg";